export enum LandingRoutePaths {
  HOME = "/",
  PAGE_NOT_FOUND = "/pageNotFound",
  HELP = "/help",
}
